import cx from 'classnames';
import styles from '../../styles/region/RegionChart.module.scss';
import { useQueryState } from '../../utils/use-query-state';
import Loading from '../Loading';
import { MetricsData } from '../metrics/use-metrics';
import MetricChart, { ChartDataType } from '../metrics/MetricChart';
import { convertChartDataForDisplay } from '../../utils/units-conversion';
import { useLinearUnitsInfo } from '../../utils/use-linear-units';

export interface RegionChartWrapperProps {
    metricsMap: Record<string, MetricsData | null> | null;
    timeRange: string;
}

const chartDataTypeItems: { key: ChartDataType; name: string }[] = [
    { key: 'tripsPerDay', name: 'Trips Per Day' },
    {
        key: 'tripDistancePerDay',
        name: 'Distance Per Day',
    },
    {
        key: 'tripsPerVehiclePerDay',
        name: 'TVD',
    },
    {
        key: 'meanActiveVehiclesPerDay',
        name: 'Average Vehicles',
    },
];

export function RegionChartWrapper({
    metricsMap,
    timeRange,
}: RegionChartWrapperProps) {
    const [selectedChartDataType, setSelectedChartDataType] = useQueryState<
        ChartDataType[]
    >('dataType', 'tripsPerDay');
    const linearUnits = useLinearUnitsInfo();

    const loadedMetrics =
        metricsMap &&
        convertChartDataForDisplay(
            selectedChartDataType,
            Object.values(metricsMap).filter(
                metric => metric != null
            ) as MetricsData[],
            linearUnits
        );

    return (
        <>
            <div className={styles.controls}>
                {chartDataTypeItems.map(chartType => (
                    <button
                        key={chartType.key}
                        type="button"
                        className={cx(
                            selectedChartDataType === chartType.key &&
                                styles.isActive
                        )}
                        onClick={() => setSelectedChartDataType(chartType.key)}
                    >
                        {chartType.name}
                    </button>
                ))}
            </div>
            <div className={styles.chartWrapperOuter}>
                <div className={styles.chartWrapperInner}>
                    <Loading loading={!loadedMetrics} />
                    {loadedMetrics && (
                        <MetricChart
                            metrics={loadedMetrics}
                            chartDataType={selectedChartDataType}
                            timeRange={timeRange}
                        />
                    )}
                </div>
            </div>
        </>
    );
}
